import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface SG7TacticalPanelProps {
  children: ReactNode;
  className?: string;
  withTexture?: boolean;
}

export function SG7TacticalPanel({ 
  children, 
  className,
  withTexture = true 
}: SG7TacticalPanelProps) {
  return (
    <div
      className={cn(
        "relative overflow-hidden",
        "rounded-xl",
        "bg-[hsl(var(--sg7-surface-1))]",
        "border border-[hsl(var(--sg7-stroke-subtle))]",
        "shadow-[var(--sg7-shadow-soft)]",
        className
      )}
    >
      {/* Top highlight line */}
      <div 
        className="absolute top-0 left-0 right-0 h-px"
        style={{
          background: 'linear-gradient(90deg, transparent 0%, hsl(var(--sg7-gold) / 0.3) 50%, transparent 100%)'
        }}
      />

      {/* Subtle grain texture */}
      {withTexture && (
        <div 
          className="absolute inset-0 pointer-events-none opacity-[0.03]"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
            backgroundRepeat: 'repeat'
          }}
        />
      )}

      {/* Tactical grid lines (very subtle) */}
      {withTexture && (
        <div 
          className="absolute inset-0 pointer-events-none opacity-[0.02]"
          style={{
            backgroundImage: `
              linear-gradient(0deg, hsl(var(--sg7-gold)) 1px, transparent 1px),
              linear-gradient(90deg, hsl(var(--sg7-gold)) 1px, transparent 1px)
            `,
            backgroundSize: '40px 40px'
          }}
        />
      )}

      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
}
